// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as Currency from "../../../../../../../library/data-source/country-currency/Currency.bs.js";
import * as CountryConfig from "../../../../../../../library/data-source/country-config/app/entity/CountryConfig.bs.js";
import * as NLOrderFareVm from "./vm-mapper/NLOrderFareVm.bs.js";
import * as CountryContext from "../../../../../../../library/data-source/country-config/context/CountryContext.bs.js";
import * as RecordsWrapper from "./RecordsWrapper.bs.js";
import * as CardTitleWithImage from "./CardTitleWithImage.bs.js";
import * as OrderFareErrorType from "../../../../app/order/entity/OrderFareErrorType.bs.js";
import * as PrimaryCard$Catalyst from "../../../../../../../../node_modules/@porterin/catalyst/src/components/custom/primary-card/PrimaryCard.bs.js";
import * as CardRowViewMapper$Catalyst from "../../../../../../../../node_modules/@porterin/catalyst/src/components/custom/cards/CardRowViewMapper.bs.js";
import * as OrderDashboardAssetsManager from "../../../assets/OrderDashboardAssetsManager.bs.js";

var info_icon = OrderDashboardAssetsManager.getImage("info.svg");

function NLOrderFareInfo$OrderFareError(Props) {
  var order_fare_error = Props.order_fare_error;
  return React.createElement("p", {
              className: order_fare_error === /* NoError */0 ? "order-fare-no-error" : "order-fare-error"
            }, OrderFareErrorType.toString(order_fare_error));
}

var OrderFareError = {
  make: NLOrderFareInfo$OrderFareError
};

function NLOrderFareInfo$FareManuallyAdjusted(Props) {
  var is_manually_adjusted_fare = Props.is_manually_adjusted_fare;
  if (is_manually_adjusted_fare !== undefined && is_manually_adjusted_fare) {
    return React.createElement("p", {
                className: "fare-manually-adjusted"
              }, "Manually Adjusted");
  } else {
    return null;
  }
}

var FareManuallyAdjusted = {
  make: NLOrderFareInfo$FareManuallyAdjusted
};

function getViewLabel(fare_info, currency) {
  var text = fare_info.vat;
  var v = fare_info.courier_fee;
  var text$1 = fare_info.underpayment_sop_status;
  return {
          hd: {
            label: "Base Fare",
            value: {
              TAG: /* Text */0,
              _0: fare_info.base_fare
            }
          },
          tl: {
            hd: {
              label: "Rounding",
              value: {
                TAG: /* Text */0,
                _0: fare_info.pre_trip_fare_round_off
              }
            },
            tl: {
              hd: {
                label: "Previous Dues",
                value: {
                  TAG: /* Text */0,
                  _0: fare_info.previous_due
                }
              },
              tl: {
                hd: {
                  label: "Waypoint Charge",
                  value: {
                    TAG: /* Text */0,
                    _0: fare_info.waypoint_charge
                  }
                },
                tl: {
                  hd: {
                    label: "Distance Charge",
                    value: {
                      TAG: /* Text */0,
                      _0: fare_info.distance_charge
                    }
                  },
                  tl: {
                    hd: {
                      label: "Toll",
                      value: {
                        TAG: /* Text */0,
                        _0: fare_info.toll
                      }
                    },
                    tl: {
                      hd: {
                        label: "VAT",
                        value: text !== undefined ? ({
                              TAG: /* Text */0,
                              _0: text
                            }) : /* NoText */0
                      },
                      tl: {
                        hd: {
                          label: "Time Charge",
                          value: {
                            TAG: /* Text */0,
                            _0: fare_info.time_charge
                          }
                        },
                        tl: {
                          hd: {
                            label: "Helper+Labour Charge",
                            value: {
                              TAG: /* Text */0,
                              _0: fare_info.helper_labour_charges
                            }
                          },
                          tl: {
                            hd: {
                              label: "Helper Charge",
                              value: {
                                TAG: /* Text */0,
                                _0: fare_info.helper_charge
                              }
                            },
                            tl: {
                              hd: {
                                label: "Porter Gold Savings",
                                value: {
                                  TAG: /* Text */0,
                                  _0: fare_info.porter_gold_savings
                                }
                              },
                              tl: {
                                hd: {
                                  label: "Coupon Discount",
                                  value: {
                                    TAG: /* Text */0,
                                    _0: fare_info.coupon_discount
                                  }
                                },
                                tl: {
                                  hd: {
                                    label: "Referral Discount",
                                    value: {
                                      TAG: /* Text */0,
                                      _0: fare_info.referral_discount
                                    }
                                  },
                                  tl: {
                                    hd: {
                                      label: "Pickup Extra Charge",
                                      value: {
                                        TAG: /* Text */0,
                                        _0: fare_info.pickup_extra_charge
                                      }
                                    },
                                    tl: {
                                      hd: {
                                        label: "Drop Extra Charge",
                                        value: {
                                          TAG: /* Text */0,
                                          _0: fare_info.drop_extra_charge
                                        }
                                      },
                                      tl: {
                                        hd: {
                                          label: "Courier Fee",
                                          value: v !== undefined && v !== Currency.toCurrencyString(Currency.toCurrency(0.0), currency) ? ({
                                                TAG: /* Text */0,
                                                _0: v
                                              }) : /* NoText */0
                                        },
                                        tl: {
                                          hd: {
                                            label: "Reward Coins Redeemed",
                                            value: {
                                              TAG: /* Text */0,
                                              _0: fare_info.rewards_discount
                                            }
                                          },
                                          tl: {
                                            hd: {
                                              label: "Underpayment Flow",
                                              value: text$1 !== undefined ? ({
                                                    TAG: /* Text */0,
                                                    _0: text$1
                                                  }) : /* NoText */0
                                            },
                                            tl: /* [] */0
                                          }
                                        }
                                      }
                                    }
                                  }
                                }
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        };
}

function NLOrderFareInfo(Props) {
  var order_fare = Props.order_fare;
  var match = CountryContext.useContext(undefined);
  var currency = CountryConfig.getSymbol(match.country);
  var fare_info = NLOrderFareVm.getVm(order_fare, currency);
  var data = order_fare.fare_details.customer;
  var order_fare_error = data !== undefined ? data.order_fare_error : order_fare.fare_details.estimated.order_fare_error;
  var data$1 = order_fare.fare_details.customer;
  var is_manually_adjusted_fare = data$1 !== undefined ? data$1.is_manually_adjusted_fare : order_fare.fare_details.estimated.is_manually_adjusted_fare;
  return React.createElement(PrimaryCard$Catalyst.make, {
              title: {
                TAG: /* Custom */1,
                _0: (function (param) {
                    return React.createElement("div", {
                                className: "fare-information-card-title-wrapper"
                              }, React.createElement(CardTitleWithImage.make, {
                                    title: "Fare Information",
                                    icon_src: info_icon
                                  }), React.createElement("div", {
                                    className: "order-fare-info-card"
                                  }, React.createElement(NLOrderFareInfo$FareManuallyAdjusted, {
                                        is_manually_adjusted_fare: is_manually_adjusted_fare
                                      }), React.createElement(NLOrderFareInfo$OrderFareError, {
                                        order_fare_error: order_fare_error
                                      })));
                  })
              },
              action: undefined,
              className: "primary-info-card payment-info",
              children: React.createElement(RecordsWrapper.make, {
                    children: CardRowViewMapper$Catalyst.CardRecordView.make("record", getViewLabel(fare_info, currency))
                  })
            });
}

var make = NLOrderFareInfo;

export {
  info_icon ,
  OrderFareError ,
  FareManuallyAdjusted ,
  getViewLabel ,
  make ,
  
}
/* info_icon Not a pure module */
